import React,{useState, useEffect} from "react";
import  "../../../css/style-new.css";
import  "../../../css/developer1.css";
// import "../../css/bootstrap.min.css";
import "../../../css/font.css";
import { Link, useNavigate } from 'react-router-dom'
import axios from "axios";
import { accreditationurl, api } from "../../../apis/urls";
import { accreditationcurl } from "../../../apis/urls";
import Loader from '../../../common-components/loader'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactPaginate from 'react-paginate';
import { $ } from "react-jquery-plugin";
import { decode } from "html-entities";

const AccreditationList = () => {

    useEffect(() => {
        setLoader(true);
        $('body').removeClass('sidebar-collapsed sidebar-active').addClass('');
        setTimeout(() => {
            Listing();
            });
    }, []);

    const [loader,setLoader] = useState(false);
    const [result,setResult] = useState([]);
    const [searchTitle, setSearchTitle] = useState("");
    const [alertText, setAlertText]=useState("");
    const[added, setAdded]=useState(false);
    const [currentpage, setCurrentpage] = useState([]);
    const [totalPages, setTotalPages] = useState([]);
    const [totalItems, setTotalItems] = useState([]);
    const [emptyItem, setEmptyItem] = useState(false);


    let counts = 0;
    if(result)
    {
        counts = result.length;
    }

    useEffect(() => {

        if(added == true){

            const notify = () => toast.success("Removed Successfully!..", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 500
              });

              notify();
        }
      }, [added])

    let navigate = useNavigate();

    const Listing = () => {

        let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({

            baseURL: accreditationurl+'?page='+0+'&size='+10,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{

            if(response.data.message === "Success"){            
                // setResult(response.data.data.items);
                setResult(response.data.data.items.sort((a, b) => b.createdAt.localeCompare(a.createdAt)));
                setCurrentpage(response.data.data.currentPage)
                setTotalPages(response.data.data.totalPages)
                setTotalItems(response.data.data.totalItems)
                setLoader(false)
                }else{
                setEmptyItem(true)
            }

           
          }).catch((error) =>{
            
            console.log('error',error.message)
            

          });
    }

    const DeletePosition = (id) => {

        let r = window.confirm("Are you sure you want to delete this Position?");

        if(r == true){
            let token = "Bearer "+localStorage.getItem('token');
        
        
            const instance = axios.create({

                baseURL: accreditationcurl+id,

                timeout: 1000000,

                headers: {'authorization': token}

            });
            
            instance.delete('').then((response) =>{
                setAdded(true);
                Listing();
                navigate('/accreditation')      
                window.location.reload()
            }).catch((error) =>{
                
                console.log('error',error.message)
            });
        }
        else{
            setAdded(false);
        }
    }


        const refreshList = () => {
            setResult(null);
        };


        let token = "Bearer "+localStorage.getItem('token');
        const instances = axios.create({
            baseURL: api,
            timeout: 1000000,
            headers: {'authorization': token}
        });

        const findByTitles = name => {
            return instances.get(`accreditations?search=${name}`);
        };

        const onChangeSearchTitle = (e) => {
            const searchTitle = e.target.value;
            setSearchTitle(searchTitle);
            findByTitles(searchTitle)
            .then(response => {
                if(response.data.message=== "Success"){
                    setResult(response.data.data.items)
                }else{
                    setResult(false)
                }
            })
            .catch(e => {
                console.log(e);
            });
        };

        const findByTitlesss = option => {
            return instances.get(`accreditations?status=${option}`);
        };

        const onChangeSearchTitles = (e) => {
            const searchTitle = e.target.value;
            findByTitlesss(searchTitle)
            .then(response => {
                if(response.data.message=== "Success"){
                    setResult(response.data.data.items)
                }else{
                    setResult(false)
                }
            })
            .catch(e => {
                console.log(e);
            });
        };


    //PAGINATION


     // Invoke when user click to request another page.
     const handlePageClick = (event) => { console.log('EVENTSSS',event)

     const instance = axios.create({
         baseURL: accreditationurl+'?page='+event.selected+'&size='+10,
         timeout: 1000000,
         headers: {'authorization': token}
       });

       

     instance.get('').then(res => {

         setResult(res.data.data.items)
     
    
     
     
         setLoader(false);
     }).catch(e => {
     //console.log('errorshw',e);
     localStorage.removeItem('token')
     navigate("/")
     });




     // const newOffset = (event.selected * 10) % items.length;
     // console.log(
     // `User requested page number ${event.selected}, which is offset ${newOffset}`
     // );
     // setItemOffset(newOffset);
 };


    let sl =1;
    return (
        <div className="wrapper">
            <aside className="right-side ">
                <div class="content-area">
                    <div className="page-title-wrpr">
                        <div className="page-title-left-column">
                            <i className="icon-suitcase1"></i>
                            <h2 className="page-title">Accreditation List</h2>
                        </div>
                        <div className="page-rightside-action-column">
                        <div class="input-groups mt-3 mb-3 search-grp">
                                <div class="input-group-prepends">
                                <select class="form-controls custom-select" onChange={onChangeSearchTitles}>
                                        <option value="none" selected disabled hidden>STATUS</option>
                                        <option value=" ">ALL</option>
                                        <option>ACTIVE</option>
                                        <option>INACTIVE</option>
                                        <option>DELETE</option>
                                    </select> 
                                </div>
                                <input type="text" 
                                class="form-controls search-bar"             
                                value={searchTitle}
                                onChange={onChangeSearchTitle}
                                placeholder="Search" />
                                <button class="btn btn-search icon-search"></button>
                                </div>
                            
                            <Link to="/add_accreditation" data-toggle="tooltip" title="" class="addbtnitem-link text-anchor" data-original-title="Add New School"><i class="icon-add"></i><span>Add New Accreditation</span> </Link>

                        </div>
                    
                    </div>

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                            
                            <li className="breadcrumb-item active" aria-current="page">Accreditation</li>
                        </ol>
				    </nav>

                        {result?
                        (<div class="number-of">
                            Displaying 1-{counts} of {totalItems} results.
                        </div>):null
                        }


                    <div className="jobs-list-wrpr list-wrpr">

                        {result?(
                        result?.map((item,index) =>
                            (
                                <div className="list " key={index}>
                                    <div className="row">

                                        <div className="col-md-1">
                                        <div class="jobs-user">
                                            Sl.No
                                            <span class="desig">{sl++}</span>
                                        </div>
                                        </div>

                                        
                                        <div className="col-md-3">
                                            <div className="jobs-user">
                                                Name
                                                <span class="desig"> {decode(item.name)}</span>
                                            </div>
                                        </div>

                                        <div className="col-md-4">
                                            <div className="jobs-user">
                                                Description
                                                <span class="desig"> {item.description}</span>    
                                            </div>
                                        </div>

                                        <div className="col-md-2">
                                            <div className="jobs-user">
                                                Status
                                                <span class="desig"> {item.status}</span>
                                            </div>
                                        </div>
                                    
                                        <div className="col-md-2">
                                            <div className="list-action-wrpr text-right  roundicons-text">
                                                <Link  to={"/edit_accreditation/"+item.id} data-toggle="tooltip" title="Edit" ><i className="edit icon-pencil3"></i><span>Update</span></Link>                                    
                                                <button  data-toggle="tooltip" title="Delete" style={{backgroundColor:'#fff'}} onClick={() => { DeletePosition(item.id) } }  ><a><i className="delete icon-close1"></i><span>Delete</span></a></button>
                                            </div>
                                        </div>
                                        <div>
                                            {/* <button onClick={notify}>Notify !</button> */}
                                            <ToastContainer
                                                style={{width: 578, marginTop: '10%', marginLeft: '8.3%'}}
                                                toastStyle={{backgroundColor: "#e74c3c", color: 'white', fontSize: 16}}
                                                progressStyle={{backgroundColor: 'white'}}
                                                
                                            />
                                        </div>
                                    </div>
                                </div>
                            )

                        )):null
                        }
                        {
                            !result?
                            (<div className="nodata">
                                <h2>Sorry! No Result Found</h2>
                            </div>):null
            
                        }
                        {result?

                        (<div class="number-of footer-number">
                            Displaying 1-{counts} of {totalItems} results.
                        </div>):null
                        }
    
                    </div>

                    { 
                        loader?
                        <div>
                            <div className="loader_container"><Loader/></div>
                        </div>
                        :
                        null
                    }

                    {
                    emptyItem?
                    (<div className="nodata">
                        <h2>Sorry! No Result Found</h2>
                    </div>):null
    
                    } 
                    {result?(
                    <div class="pagination-wrpr">
                        <ReactPaginate
                                className="pagination page"
                                pageClassName="page-item"
                                activeClassName="active"
                                nextLabel=">"
                                previousLabel="<"
                                previousClassName="page-link p-link"
                                nextClassName="page-link p-link"
                                onPageChange={handlePageClick}
                                pageRangeDisplayed={10}
                                pageCount={totalPages}
                                renderOnZeroPageCount={1}
                            />
                        </div>):null
                        } 

                </div>
            </aside>
        </div>
    )
}

export default AccreditationList;